import { render, staticRenderFns } from "./SidebarSharePlugin.vue?vue&type=template&id=7842b0a2&"
import script from "./SidebarSharePlugin.vue?vue&type=script&lang=js&"
export * from "./SidebarSharePlugin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports